import axios from '@/lib/axios'

export interface VapidPublicKeyResponse {
  publicKey: string
}

class VapidService {
  private static instance: VapidService
  private cachedPublicKey: string | null = null

  private constructor() {}

  static getInstance(): VapidService {
    if (!VapidService.instance) {
      VapidService.instance = new VapidService()
    }
    return VapidService.instance
  }

  async getVapidPublicKey(): Promise<string> {
    if (this.cachedPublicKey) {
      return this.cachedPublicKey
    }

    try {
      const response = await axios.get<VapidPublicKeyResponse>('/push-notifications/vapid-public-key')
      this.cachedPublicKey = response.data.publicKey
      return this.cachedPublicKey
    } catch (error) {
      console.error('Failed to fetch VAPID public key:', error)
      throw new Error('Failed to fetch VAPID public key')
    }
  }

  clearCache() {
    this.cachedPublicKey = null
  }
}

export default VapidService
